import { createApi } from '@reduxjs/toolkit/query/react'

import { OrderDirection } from '@/constants/order-direction'
import {
  infiniteOffsetPaginationQueryOptions,
  OffsetPaginationRequest,
  PaginationResponse,
} from '@/model/pagination'
import { Competition } from '@/redux/competition'
import { User } from '@/redux/user'
import { baseQuery } from '@/redux/utils'

export enum RankingOrderField {
  Ranking = 'ranking',
  SharpeRatio = 'sharpeRatio',
  ROI = 'roi',
  PNL = 'pnl',
  MaxDrawDown = 'maxDrawDown',
}

export interface Ranking {
  change: number
  isNew: boolean
  maxDrawDown: number
  pnl: number
  ranking: number
  roi: number
  sharpeRatio: number
  user: Pick<User, 'id' | 'nickname' | 'wallets' | 'avatar'> | null
}

export interface ReadRankingRequest {
  orderField?: RankingOrderField
  orderDirection?: OrderDirection
}

export interface RankingPaginationResponse extends PaginationResponse<Ranking> {
  competition: Competition
}

export const rankingSlice = createApi({
  reducerPath: 'ranking',
  baseQuery,
  endpoints: builder => ({
    readRanking: builder.infiniteQuery<RankingPaginationResponse, ReadRankingRequest | void, OffsetPaginationRequest>(
      {
        infiniteQueryOptions: infiniteOffsetPaginationQueryOptions,
        query: ({ queryArg, pageParam }) => ({
          url: '/ranking',
          params: {
            ...queryArg,
            ...pageParam,
          },
        }),
      }),
  }),
})

export const {
  useReadRankingInfiniteQuery,
} = rankingSlice
